import { render, staticRenderFns } from "./ClientField.vue?vue&type=template&id=3f4632c1&scoped=true&lang=true&"
import script from "./ClientField.vue?vue&type=script&lang=js&"
export * from "./ClientField.vue?vue&type=script&lang=js&"
import style0 from "./ClientField.vue?vue&type=style&index=0&id=3f4632c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4632c1",
  null
  
)

export default component.exports